const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const probabilityHeatStyle = (value) => {
    const numericValue = Number(value);
    const probability = clamp(Number.isFinite(numericValue) ? numericValue : 0, 0, 1);
    const intensity = Math.pow(probability, 0.9);

    return {
        backgroundColor: `hsl(43 78% ${96 - intensity * 21}%)`,
        borderColor: `hsl(43 73% ${82 - intensity * 24}%)`,
        boxShadow: `inset 0 0 0 1px hsla(43, 70%, ${78 - intensity * 28}%, 0.35)`,
    };
};
